import { useState } from 'react';

import { ISetState } from '../../shared/types/ISetState';

export type IUseModal = {
    isOpen: boolean;
    showModal: () => void;
    hideModal: () => void;
};

export function useModal (): IUseModal {
    const [isOpen, setIsOpen]: [boolean, ISetState<boolean>] = useState<boolean>(false);

    function showModal (): void {
        setIsOpen(true);
    }

    function hideModal (): void {
        setIsOpen(false);
    }

    return {
        isOpen,
        showModal,
        hideModal,
    };
}
